import { render } from "./AppRedirect.vue?vue&type=template&id=1ea6feae&scoped=true&ts=true"
import script from "./AppRedirect.vue?vue&type=script&lang=ts"
export * from "./AppRedirect.vue?vue&type=script&lang=ts"

import "./AppRedirect.vue?vue&type=style&index=0&id=1ea6feae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea6feae"]])

export default __exports__